<template>
    <footer>
        <div class="wrapper">
            <span>{{ $t('profile.footer.authenticated') }}&nbsp;<Icon name="logo-trustfolio"/></span>
            <div>
                <ul>
                    <li>
                        <AnchorLink to="/entreprises">Métiers</AnchorLink>
                    </li>
                    <li>
                        <AnchorLink to="/articles">Articles</AnchorLink>
                    </li>
                    <li v-if="$store.getters.windowWidth <= $breakpoints.list.l">
                        <AnchorLink to="/app/#/profile">Mon Compte</AnchorLink>
                    </li>
                </ul>
                <Button :inverted="true" type="stroke" to="/">Créer mon trustfolio</Button>
                <AnchorLink to="/legal/vie-privee">Données personnelles</AnchorLink>
                <AnchorLink to="/legal/mentions-legales">Mentions légales</AnchorLink>
            </div>
        </div>
        <Dots :color="primaryColor"/>
    </footer>
</template>

<script>
import Dots from '~/components/Dots';

export default {
    components: {
        Dots
    },
    computed: {
        primaryColor() {
            return this.$store.state.primaryColor;
        }
    }
};
</script>


<style lang="scss" scoped>
footer {
    position: relative;
    padding: 35px 40px;
    font-size: 1.2rem;
    text-align: center;
    background: $black;
    color: $white;
    .dots {
        position: absolute;
        @include dots(40, 2);
        top: -$gutter * 4;
        right: 0;
    }
    .icon-logo-trustfolio {
        width: 99px;
        height: 22px;
        margin-left: $gutter / 2;
    }
    ul {
        margin: $gutter * 4 0;
        font-size: 1.3rem;
        font-weight: 600;
        list-style: none;
        .link {
            display: block;
            text-decoration: none;
            color: $white;
        }
    }
    li {
        margin: 0 0 0.8em;
    }
    .btn {
        margin: 0 0 4em;
        font-weight: 600;
    }
    .link {
        display: block;
        margin: 0 0 10px;
        color: $mid-grey;
    }
}

@media (min-width: $desktop-small) {
    footer {
        display: flex;
        justify-content: center;
        padding: 30px $gutter * 3;
        align-items: center;
        .dots {
            position: absolute;
            @include dots(19, 6);
            top: -$gutter * 4;
            right: 0;
        }
        .wrapper {
            display: flex;
            flex-direction: column;
            div {
                display: flex;
                align-items: center;
                margin-top: $line-height;
            }
        }
        ul {
            display: flex;
            align-items: center;
            margin: 0;
        }
        li {
            margin: 0 25px 0 0;
        }
        .btn {
            margin: 0;
        }
        .link {
            margin: 0 0 0 15px;
            text-decoration: none;
        }
    }
}

@media (min-width: $desktop) {
    footer {
        padding: 30px $gutter * 6;
        .dots {
            @include dots(19, 4);
            top: auto;
            bottom: 0;
        }
        li {
            margin: 0 35px 0 0;
        }
        .wrapper {
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            div {
                margin-top: 0;
            }
        }
        .link {
            margin: 0 0 0 25px;
        }
    }
}

@media (min-width: $desktop-large) {
    footer {
        .dots {
            @include dots(19, 6);
            right: $gutter * 2;
        }
        .wrapper {
            max-width: 1100px;
        }
    }
}
</style>
